<template>
    <v-app>
        <AppBarFrame
            :session="session"
            :environment="environment"
            :generalExApplicationEx="generalExApplicationEx"
            :applicationName="applicationName"
            :customLanguage="customLanguage"
            :alertsCount="alertsCount"
            @toggle-menu-bar-drawer="toggleMenuBarDrawer"
            @toggle-alert-bar-drawer="toggleAlertBarDrawer"
            @logoff="logoff"
            @go-home="goHome"
            @go-applications="goApplications"
            @switch-language="switchLanguage"
            ref="appBarRef"
        />
        <MenuBarFrame
            :session="session"
            :environment="environment"
            :generalExApplicationEx="generalExApplicationEx"
            :applicationName="applicationName"
            :menu="menu"
            :customLanguage="customLanguage"
            @sel-menu="selMenu"
            ref="menuBarFrame"
        />
        <AlertBarFrame
            :session="session"
            :environment="environment"
            :generalExApplicationEx="generalExApplicationEx"
            :applicationName="applicationName"
            :menu="menu"
            :customLanguage="customLanguage"
            @update-alerts="updateAlerts"
            ref="alertBarFrame"
        />
        <WideFrame
            :session="session"
            :environment="environment"
            :generalExApplicationEx="generalExApplicationEx"
            :applicationName="applicationName"
            :menu="menu"
            :customLanguage="customLanguage"
            @success-login="successLogin"
            @clear-login="clearLogin"
            @update-notification="updateNotification"
            @switch-language="switchLanguage"
            @sel-menu="selMenu"
            @user-interaction="userInteraction"
            ref="wideFrameRef"
        />
        <ApplicationSelection
            :session="session"
            :environment="environment"
            :generalExApplicationEx="generalExApplicationEx"
            :applicationName="applicationName"
            :customLanguage="customLanguage"
            @select-application="selectApplication"
            @logoff="logoff"
            @switch-language="switchLanguage"
            ref="applicationSelectionRef"
        />
        <SystemBar
            :session="session"
            :generalExApplicationEx="generalExApplicationEx"
            :environment="environment"
            :secondsLeft="secondsLeft"
            ref="systemBarRef"
        />
        <Notification
            :session="session"
            :generalExApplicationEx="generalExApplicationEx"
            :environment="environment"
            :notifications="notifications"
            ref="notificationRef"
        />
    </v-app>
</template>

<script>
import AppBarFrame from "./AppBarFrame";
import WideFrame from "./WideFrame";
import MenuBarFrame from "./MenuBarFrame";
import AlertBarFrame from "./AlertBarFrame";
import ApplicationSelection from "./../application/ApplicationSelection";
import SystemBar from "./SystemBar";
import Notification from "./Notification";
import { environment } from "./../../../environment/environment.js";
import moment from "moment";

export default {
    name: "Main",
    inheritAttrs: false,
    data() {
        return {
            environment: environment,
            menuBarDrawer: false,
            alertBarDrawer: false,
            dialog: {},
            menu: {},
            generalExApplicationEx: {},
            // sessionGral: {},
            // sessionApp: {},
            session: {
                loggedIn: false,
                details: {},
            },
            applicationName: null,
            showAppSel: false,
            notifications: [],
            customLanguage: null,
            historyNotif: [],
            timeoutNotif: 3000,
            alertsCount: 0,
            sessionInteractionTimeout: null,
            limitNoInteractions: null,
            secondsLeft: null,
        };
    },
    components: {
        AppBarFrame,
        WideFrame,
        MenuBarFrame,
        SystemBar,
        ApplicationSelection,
        Notification,
        AlertBarFrame,
    },
    methods: {
        toggleMenuBarDrawer() {
            this.$refs.menuBarFrame.toggleMenuBarDrawer();
            this.userInteraction({ type: "toggle-menu", data: {} });
        },
        toggleAlertBarDrawer() {
            this.$refs.alertBarFrame.toggleAlertBarDrawer();
            this.userInteraction({ type: "toggle-alert", data: {} });
        },
        successLogin(data) {
            this.saveSession(data);
            this.goApplications();
            this.$forceUpdate();
            this.goHome();
        },
        clearLogin() {
            this.clearSession();
        },
        clearApplication() {
            this.applicationEx = {};
        },
        logoff() {
            this.closeApplicationSession(
                this.applicationName,
                this.generalExApplicationEx
            );
            /*
            if (
                this.notBlank(this.applicationName) &&
                this.generalExApplicationEx.appLogin
            ) {
                this.goToLogin(this.applicationName);
            } else {
                this.goToLogin();
            }
            */
        },
        selMenu(data) {
            this.menu = data;
            this.menu.selected = true;
            this.$refs.wideFrameRef.callTransaction(this.menu);
            this.userInteraction({ type: "menu", data });
        },
        goHome() {
            if (this.menu.selected) {
                this.menu = {};
                this.$refs.wideFrameRef.cleanData();
            }
            this.menu = {};
            this.$refs.wideFrameRef.goHome(
                this.generalExApplicationEx.applicationEx.application.name,
                this.session
            );
            this.userInteraction({
                type: "home",
                data: { applicationName: this.applicationName },
            });
            //this.launchInteractionsWatcher();
        },
        goApplications() {
            this.$refs.applicationSelectionRef.showApplications();
            this.userInteraction({ type: "applications", data: {} });
        },
        selectApplication(application) {
            this.goToApplication(application.name);
            this.userInteraction({ type: "application", data: application });
        },

        setAll() {
            this.limitNoInteractions =
                this.generalExApplicationEx?.authentication?.limitNoInteractions;
            /*
            if (this.applicationName) {
                if (this.generalExApplicationEx?.appLogin) {
                    if (!this.sessionApp.loggedIn) {
                        this.goToLogin(this.applicationName);
                    }
                } else {
                    if (this.sessionGral.loggedIn) {
                        this.goHome();
                        this.$refs.alertBarFrame.loadAlertsBackground(
                            this.generalExApplicationEx
                        );
                    } else {
                        this.goToLogin();
                    }
                }
            } else {
                if (this.sessionGral.loggedIn) {
                    this.goApplications();
                } else {
                    this.goToLogin();
                }
            }
            */
            if (!this.applicationName && this.session.loggedIn) {
                this.goApplications();
            } else {
                this.goHome();
            }
        },

        loadMain() {
            this.generalExApplicationEx = {};
            this.apiGetGeneralApplication({
                path: { applicationName: this.applicationName },
            })
                .then((dataRes) => {
                    this.session = this.validateApplicationSession(
                        this.applicationName,
                        dataRes,
                        false
                    );
                    this.generalExApplicationEx = dataRes.data;
                    this.setAll();
                    this.launchInteractionsWatcher();
                    this.userInteraction({
                        type: "main",
                        data: { applicationName: this.applicationName },
                    });
                })
                .catch((errorRes) => {
                    console.log(errorRes);
                    this.clearSession(this.applicationName);
                    this.clearFrameworkSession();
                    if (errorRes.response.status == 403) {
                        this.launch();
                    } else {
                        this.goToErrorServiceUnavaliable({ mesage: errorRes });
                    }
                });
        },

        showAllSel() {
            return this.emptyString(this.applicationName);
        },

        /*
        session() {
            let session = {};
            if (
                this.notBlank(this.applicationName) &&
                this.generalExApplicationEx.appLogin
            ) {
                session = this.loadSession(this.applicationName);
            } else {
                session = this.loadSession();
            }
            return session;
        },
        */

        updateNotification(data) {
            const add = this.formattedNotification(data);
            this.notifications.push(...add);
            this.$refs.notificationRef.open();
            setTimeout(() => {
                this.cleanNotifications();
            }, this.timeoutNotif);
        },

        cleanNotifications() {
            this.historyNotif.concat(this.notifications);
            this.notifications = [];
        },

        switchLanguage() {
            this.customLanguage = this.changeLanguage(
                this.generalExApplicationEx
            );
        },

        updateAlerts(args) {
            this.alertsCount = args.count;
        },
        userInteraction(args) {
            let data = args;
            data.stamp = moment().valueOf();
            this.saveSessionInteraction(data, this.applicationName);
        },

        validateInactivity() {
            let result = true;
            const interaction = this.loadSessionInteraction(
                this.applicationName
            );
            if (interaction && this.limitNoInteractions) {
                const currentStamp = moment().valueOf();
                const diff = currentStamp - interaction.stamp;
                this.secondsLeft = Math.round(
                    (this.limitNoInteractions - diff) / 1000
                );
                if (diff > this.limitNoInteractions) {
                    this.logoff();
                    clearTimeout(this.queryTimeout);
                    result = false;
                }
            }
            return result;
        },

        launchInteractionsWatcher() {
            if (this.sessionInteractionTimeout) {
                clearTimeout(this.queryTimeout);
            }
            const firstValidation = this.validateInactivity();
            if (firstValidation && this.applicationName) {
                this.sessionInteractionTimeout = setTimeout(() => {
                    const validation = this.validateInactivity();
                    if (validation) {
                        this.launchInteractionsWatcher();
                    }
                }, 5000);
            }
        },

        launch() {
            this.validateFrameworkSession()
                .then(() => {
                    this.applicationName = this.$route.params.applicationName;
                    //this.sessionGral = this.loadSession();
                    //this.sessionApp = this.loadSession(this.applicationName);
                    this.customLanguage = this.currentLanguage();
                    this.loadMain();
                })
                .catch(() => {
                    this.goToErrorUnauthorized({});
                });
        },
    },
    created() {
        this.launch();
    },
    updated() {},
};
</script>

<style>
</style>